/* eslint-disable max-len */

import React from 'react'
import { Link } from 'react-router-dom'

export default function Draft({orderSuccess,orderFlow}) {
    return (
        <div className="modal-dialog modal-dialog-centered relative lg:max-w-[443px] lg:min-w-[443px] w-full px-3 pointer-events-none" style={{margin: 'auto'}}>
            <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white border border-[#707070] bg-clip-padding rounded-md outline-none text-current md:px-[50px] sm:px-5 px-3 sm:pt-[32px] pt-4 pb-5">
                <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                    <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                        Draft Order Placed
                    </h5>
                </div>
                <div className="modal-body sm:pt-6 pt-5">
                    <img src="/images/clock.png" alt="icon" className="mx-auto" />
                    <p className="sm:pt-4 pt-3 text-center text-xs6 font-normal text-[#090406]">Thank you, your order is under review.</p>
                    <p className="text-center text-xs6 font-normal text-[#090406]">Once accepted/Rejected you will be notified in your email. You can track your order in the My Orders section post-order acceptance</p>
                    {orderSuccess.map((item,i)=>(
                        <p key={i}className="sm:pt-6 pt-4 sm:text-xl text-lg font-semibold leading-normal text-[#090406] text-center">
                            <span className='flex justify-center'>Order Number: {item}</span></p>
                    ))}
                    <div className="pt-3.5 w-full">
                        <Link to="/orders" className="w-full flex justify-center">
                            <button type="button" className="w-full sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                                Go to Orders
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}
